import styled from 'styled-components/macro'
import mobileSignupBackground from '../../../../../assets/images/desktop_signup_bg.jpg'
import desktopSignupBackground from '../../../../../assets/images/desktop_signup_bg.jpg'
import { device } from '../../../../../constants/media-query'

export const SignupContainer = styled.form`
  width: 100vw;
  padding-bottom: 60px;
  direction: rtl;

  @media ${device.desktop} {
    display: flex;
    padding-bottom: 0px;
    background: url(${desktopSignupBackground});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 0;
    height: 100vh;
  }
`

export const SignupFormBg = styled.div`
  /* background: url(${mobileSignupBackground}); */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 120px;

  @media ${device.desktop} {
  }
`

export const SignupFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  direction: rtl;
  padding: 60px 25px 0;
  background: #ffffff;

  @media ${device.desktop} {
    width: 35%;
    justify-content: center;
    border-radius: 25px;
    margin: 12px;
  }
`

export const SignupFormHeader = styled.div`
  padding: 0 0 32px;
  text-align: center;
`

export const SignupFormTitle = styled.div`
  font-weight: 500;
  font-size: 36px;
  line-height: 41px;
  letter-spacing: -0.075em;
  color: #000000;
`

export const SignupFormSubtitle = styled.div`
  font-weight: 500;
  font-size: 20px;
  line-height: 25px;
  letter-spacing: -0.075em;
  color: #757575;
`

export const SignupFormBody = styled.form``

export const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`
